"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountUserConverter = void 0;
const LinkEntity_1 = require("../common/model/LinkEntity");
class AccountUserConverter {
}
exports.AccountUserConverter = AccountUserConverter;
AccountUserConverter.convert = (entity) => {
    let links = undefined;
    if (entity._links?.sendActivationEmail !== undefined) {
        links = {
            sendActivationEmail: new LinkEntity_1.Link(entity._links?.sendActivationEmail),
        };
    }
    return {
        id: entity.id,
        email: entity.email,
        firstName: entity.firstName,
        lastName: entity.lastName,
        permissions: {
            canOrder: entity.permissions.canOrder,
            canManageUsers: entity.permissions.canManageUsers,
        },
        accessExpiresOn: entity.accessExpiresOn
            ? new Date(entity.accessExpiresOn)
            : undefined,
        links,
    };
};
AccountUserConverter.fromPageableAccountUsersEntity = (entity) => {
    return {
        page: entity._embedded.accountUsers.map((accountUser) => AccountUserConverter.convert(accountUser)),
        pageSpec: entity.page
            ? {
                totalPages: entity.page.totalPages,
                number: entity.page.number,
                size: entity.page.size,
                totalElements: entity.page.totalElements,
            }
            : undefined,
    };
};
AccountUserConverter.fromAccountUserProfileEntity = (entity) => {
    return {
        id: entity.id,
        email: entity.email,
        firstName: entity.firstName,
        lastName: entity.lastName,
    };
};
//# sourceMappingURL=AccountUserConverter.js.map